import React from 'react';
import { Box, Typography, IconButton } from '@material-ui/core';
import { Edit as EditIcon } from '@material-ui/icons';
import numeral from 'numeral';

const Review = ({ formData, company, setActiveStep }) => {

  const partialSalesPropertyCasualty = company.feature_types.includes('partial_sales_property_casualty');
  const hideProductSalesPurchasePrice = company?.feature_types?.includes('hide_partial_sales_purchase_price') || false;
  const partialSalesDetailedQuestions = company.feature_types.includes('partial_sales_detailed_questions');
  
  // Helper to render field with edit icon
  const FieldWithEdit = ({ label, value, stepIndex, title }) => (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography variant="body2">
        <b>{label}:</b> {value}
      </Typography>
      <IconButton 
        size="small" 
        onClick={() => setActiveStep(stepIndex)}
        title={title || `Edit ${label}`}
        style={{ padding: '4px' }}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    </Box>
  );

  return (
    <div>
      <Box>
        <Typography variant="h6" gutterBottom>
          Review Details
        </Typography>
        <FieldWithEdit 
          label="Listing Title" 
          value={formData.segmentDetails}
          stepIndex={3}
          title="Edit Title & Description"
        />
        <Typography variant="body2">
          <b>Description:</b> {formData.description}
        </Typography>
        <hr/>
        <FieldWithEdit 
          label="Number of Clients" 
          value={formData.numberOfClients}
          stepIndex={0}
          title="Edit Financial Details"
        />
        <Typography variant="body2">
          <b>{partialSalesPropertyCasualty ? "Total Premium" : "Assets Under Management"}:</b> {numeral(formData.assetsUnderManagement).format('$0,0.00')}
        </Typography>
        <Typography variant="body2">
          <b>{partialSalesPropertyCasualty ? "Recurring Commission Revenue" : "Fee Based Revenue"}:</b> {numeral(formData.feeBasedRevenue).format('$0,0.00')}
        </Typography>
        {!partialSalesPropertyCasualty && (
          <>
            <Typography variant="body2">
              <b>Trailer Revenue:</b> {numeral(formData.trailerRevenue).format('$0,0.00')}
            </Typography>
            <Typography variant="body2">
              <b>Direct Revenue:</b> {numeral(formData.directRevenue).format('$0,0.00')}
            </Typography>
          </>
        )}
        <Typography variant="body2">
          <b>{partialSalesPropertyCasualty ? "New Commission Revenue" : "Commission Revenue"}:</b> {numeral(formData.commissionRevenue).format('$0,0.00')}
        </Typography>
        <hr/>
        {formData.questions.map((question, index) => (
          <FieldWithEdit 
            key={index}
            label={question}
            value={formData.answers[index] ? 'Yes' : 'No'}
            stepIndex={1}
            title="Edit Details"
          />
        ))  
        }
        <FieldWithEdit 
          label="States"
          value={Array.isArray(formData.states) ? formData.states.join(', ') : formData.states}
          stepIndex={1}
          title="Edit Details"
        />
        {partialSalesDetailedQuestions && (
          <>
            <Typography variant="body2">
              <b>Client Demographics:</b> {formData.clientDemographicsDetails}
            </Typography>
            <Typography variant="body2">
              <b>Services Provided:</b> {formData.servicesProvidedDetails}
            </Typography>
            <Typography variant="body2">
              <b>Other:</b> {formData.otherDetails}
            </Typography>
          </>
        )}
        <hr/>
        {!hideProductSalesPurchasePrice && (
          <FieldWithEdit 
            label="Asking Price"
            value={formData.askingPrice === 0 ? 'Negotiable' : numeral(formData.askingPrice).format('$0,0.00')}
            stepIndex={2}
            title="Edit Price Details"
          />
        )}
      </Box>
    </div>
  );
};

export default Review;
